import { render } from "./AdminSQL.vue?vue&type=template&id=651124c0&scoped=true"
import script from "./AdminSQL.vue?vue&type=script&lang=js"
export * from "./AdminSQL.vue?vue&type=script&lang=js"

import "./AdminSQL.vue?vue&type=style&index=0&id=651124c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651124c0"]])

export default __exports__